import api from './api'

export const therapistService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.keyword) query.append('keyword', params.keyword)
    if (params.status) query.append('status', params.status)
    if (params.teamId) query.append('teamId', params.teamId)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/therapists?${query.toString()}`)
  },
  create(payload) {
    return api.post('/therapy/therapists', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/therapists/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/therapists/${id}/status`, null, { params: { status } })
  },
  checkDeactivate(id) {
    return api.get(`/therapy/therapists/${id}/deactivate-check`)
  },
  fetchNotifyCandidates(phone) {
    const query = new URLSearchParams()
    query.append('phone', phone)
    return api.get(`/therapy/therapists/notify-candidates?${query.toString()}`)
  }
}
